export default __webpack_public_path__ + "static/media/SaveBlue.99ec17b9.svg";